// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"01c71398","455":"4247a312","977":"720fae72"}[chunkId] + ".chunk.js";
};